export default __webpack_public_path__ + "assets/images/5d79bec8aa8b5a9ad75d3c34b94bb7bb.gif";